// Import Input namespace from the main package
import { Input as DSInput } from "@packages/ds";

// Import types
import type {
  InputProps,
  InputRootProps,
  InputErrorProps,
  InputInputProps
} from "@packages/ds";

// Extract the properties for re-export
const Root = DSInput.Root;
const Error = DSInput.Error;

// Re-export the Input namespace as-is
const Input = DSInput;

// Re-export components via named exports
export { Input, Root, Error, Input as InputPrimitive };

// Re-export types
export type { InputProps, InputRootProps, InputErrorProps, InputInputProps };

// Default export for backward compatibility
export default Input;
